import React, { useState, useEffect, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import './Toast.scss'
import { GlobalContext } from '../../../services/context'

const Toast = ({
  companyInfo,
  _showModal,
  _setShowModal,
  message = 'Thank you! Your request was successfully submited'
}) => {
  const history = useHistory()
  const { dispatch } = useContext(GlobalContext)
  const [showModal, setShowModal] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      if (_setShowModal) {
        _setShowModal(false)
      } else {
        setShowModal(false)
      }
      if (companyInfo) {
        dispatch({
          type: 'SET_DETAIL_VIEW',
          payload: { previous: 'Company', title: companyInfo.company_name }
        })
        history.push(`/company/${companyInfo.company_id}`)
      }
    }, 1500)
    return () => {
      clearTimeout(timer)
    }
  }, [showModal, _showModal, _setShowModal, history, companyInfo, dispatch])

  if (_showModal || showModal) {
    return (
      <div className="toast">
        <div className="childToast">
          <p>{message}</p>
        </div>
      </div>
    )
  } else {
    return null
  }
}

export default Toast
